<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="SearchContainer" :scrId="scrId" @selectChecks="selectChecks" />
				</sf-card>
			</div>
			<sf-card class="p-0 border-0 bg-transparent h-100">
				<action-buttons
					ref="ActionButtons"
					:scrId="scrId"
					@selectDetails="selectDetails"
					@Refresh="Refresh"
					@openReport="openReport"
					@selectUnChecks="selectUnChecks"
				></action-buttons>
			</sf-card>
			<div class="sf-col sf-col-5">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<form-container ref="FormContainer" :scrId="scrId"></form-container>
				</sf-card>
			</div>
			<div class="sf-col sf-col-13">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container ref="TableContainer" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
		<popup-open ref="popupReport" @Refresh="Refresh" :scrId="scrId"></popup-open>
	</div>
</template>

<script>
import SearchContainer from './Search/Search.vue';
import ActionButtons from './Table/ActionButtons.vue';
import TableContainer from './Table/Table.vue';
import FormContainer from './Table/Form.vue';
import PopupOpen from '@pqy/ptin/PowTourStts/Content/Popup/Popup.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourRgst/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	components: { SearchContainer, ActionButtons, TableContainer, FormContainer, PopupOpen },
	methods: {
		...rootMethods,
		...serviceMethods,
		openReport(row) {
			//console.log('open popup', row);
			this.$refs.popupReport.open(row);
		},
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.SearchContainer.searchList();
		},
		selectDetails() {
			//임시저장, 작성 버튼 클릭시 그리드에 체크박스 선택된 데이터를 알 수 있도록 한다.
			const selectedDatas = this.$refs.TableContainer.gridCheckRowData();
			this.setSelectedRows_(selectedDatas);
		},
		selectUnChecks() {
			//이미 저장된 데이터는 조회시 그리드 체크박스를 자동으로 선택하도록 한다.
			this.$refs.TableContainer.selectUnCheck();
		},
		selectChecks() {
			//이미 저장된 데이터는 조회시 그리드 체크박스를 자동으로 선택하도록 한다.
			this.$refs.TableContainer.selectCheck();
		}
	}
};
</script>

<style></style>
